module.exports = __webpack_public_path__ + "img/安防工程企业设计施工维护能力证书.304c34df.png";